import axiosInstance from "../services/axiosConfig";
import { API_PATHS } from "./config";

export const getReferralShareInfo = async (userId) => {
  return axiosInstance.get(`${API_PATHS.BASE_API_URL}/referral/share`, {
    params: { user_id: userId },
  });
};

export default { getReferralShareInfo };
